import _classCallCheck from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import Shareable from '@shared/models/shareable';
import moment from '@shared/services/moment';
import { max, min } from '@shared/services/moment';

var TimeSpan = /*#__PURE__*/function (_Shareable) {
  _inherits(TimeSpan, _Shareable);

  var _super = _createSuper(TimeSpan);

  function TimeSpan() {
    _classCallCheck(this, TimeSpan);

    return _super.apply(this, arguments);
  }

  _createClass(TimeSpan, [{
    key: "equals",
    value: function equals(other) {
      return this.start.isSame(other.start) && this.end.isSame(other.end);
    }
  }, {
    key: "containsMoment",
    value: function containsMoment(otherMoment) {
      return (this.start.isBefore(otherMoment) || this.start.isSame(otherMoment)) && this.end.isAfter(otherMoment);
    }
  }, {
    key: "containsTimeSpan",
    value: function containsTimeSpan(timeSpan) {
      return this.equals(timeSpan) || this.containsMoment(timeSpan.start) && this.containsMoment(timeSpan.end);
    }
  }, {
    key: "containsTimeSpanInclusive",
    value: function containsTimeSpanInclusive(timeSpan) {
      return this.withEnd(this.end.clone().add(1, 'second')).containsTimeSpan(timeSpan);
    }
  }, {
    key: "intersects",
    value: function intersects(other) {
      return this.start.unix() <= other.end.unix() - 1 && other.start.unix() <= this.end.unix() - 1;
    }
  }, {
    key: "merge",
    value: function merge(other) {
      var time = {
        start: min(this.start, other.start).unix(),
        end: max(this.end, other.end).unix()
      };
      return this.constructor.fromPlainObject(time);
    }
  }, {
    key: "withStart",
    value: function withStart(startMoment) {
      return this.constructor.fromPlainObject({
        start: startMoment.unix(),
        end: this.end.unix()
      });
    }
  }, {
    key: "withEnd",
    value: function withEnd(endMoment) {
      return this.constructor.fromPlainObject({
        start: this.start.unix(),
        end: endMoment.unix()
      });
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return moment.duration(this.end.diff(this.start));
    }
  }], [{
    key: "fromPlainObject",
    value: function fromPlainObject(obj) {
      if (!obj) {
        return new NullTimeSpan();
      }

      var timeSpan = new this();
      timeSpan.start = moment.unix(obj.start);
      timeSpan.end = moment.unix(obj.end);

      if (timeSpan.start.isAfter(timeSpan.end)) {
        throw new Error("TimeSpan start (".concat(timeSpan.start.unix(), ") > end (").concat(timeSpan.end.unix(), ")"));
      }

      return timeSpan;
    }
  }, {
    key: "shareableFields",
    value: function shareableFields() {
      return ['start', 'end'];
    }
  }]);

  return TimeSpan;
}(Shareable);

export { TimeSpan as default };
export var NullTimeSpan = /*#__PURE__*/function (_TimeSpan) {
  _inherits(NullTimeSpan, _TimeSpan);

  var _super2 = _createSuper(NullTimeSpan);

  function NullTimeSpan() {
    _classCallCheck(this, NullTimeSpan);

    return _super2.apply(this, arguments);
  }

  _createClass(NullTimeSpan, [{
    key: "isNull",
    value: function isNull() {
      return true;
    }
  }]);

  return NullTimeSpan;
}(TimeSpan);